var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.099,58.329H20.876 l-3.818-3.941 M68.789,58.329h10.224l3.817-3.941 M31.346,66.426H68.42 M64.461,27.599c-0.947-2.26-3.334-7.946-3.678-8.684 c-0.432-0.923-0.555-1.848-2.095-1.848c-1.491,0-7.126,0-8.621,0c0,0-0.137,0-0.37,0c-1.495,0-7.13,0-8.621,0 c-1.54,0-1.663,0.924-2.094,1.848c-0.345,0.737-2.731,6.424-3.678,8.684 M35.305,27.599h11.376h2.71h1.131h2.71h11.229  M35.305,27.599h-5.006h-1.663c-2.34,0-3.202,1.231-4.251,3.142l-5.408,10.065 M18.977,40.806l-0.06,0.11 M80.896,40.733 l-5.371-9.993c-1.047-1.91-1.909-3.142-4.25-3.142h-1.662h-5.152 M18.977,40.806c1.037,1.407,2.208,2.995,2.208,2.995l6.281,2.15 h20.223h4.534h20.223l6.282-2.15l2.169-3.067 M12.655,73.065c1.108,0.982,2.562,1.584,4.161,1.584h32.068h0.69h0.849h0.691h32.067 c1.487,0,2.852-0.52,3.929-1.383 M18.977,40.806c-0.745-1.01-1.422-1.927-1.545-2.093c-0.297-0.399-0.573-1.046-1.605-1.046 c-1.509,0-9.298,0-9.298,0c-1.157,0-2.095,0.938-2.095,2.095v4.31c0,1.509,1.17,1.941,2.095,2.095c0,0,7.819,1.201,7.819,2.001 s-3.815,3.51-3.815,9.545v5.546v5.105c0,1.873,0.823,3.55,2.123,4.701 M87.111,73.267c1.435-1.152,2.355-2.918,2.355-4.902v-5.105 v-5.546c0-6.035-3.816-8.745-3.816-9.545s7.821-2.001,7.821-2.001c0.925-0.153,2.095-0.585,2.095-2.095v-4.31 c0-1.157-0.938-2.095-2.095-2.095c0,0-7.708,0-9.298,0c-1.312,0-1.65,0.529-1.996,1.057c-0.349,0.529-1.281,2.009-1.281,2.009  M12.655,73.065v7.771c0,1.157,0.938,2.096,2.095,2.096h14.471c1.156,0,2.095-0.938,2.095-2.096v-1.97 M12.655,73.065  M87.111,73.267 M68.45,78.867v1.97c0,1.157,0.938,2.096,2.095,2.096h14.471c1.157,0,2.096-0.938,2.096-2.096v-7.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.a9cb1bd7c9695b96d5504aacf292cb1b.svg";
export { ForwardRef as ReactComponent };